[
  {
    "type": "A",
    "month1": 550,
    "month2": 620,
    "month3": 480,
    "month4": 700,
    "month5": 590,
    "month6": 560,
    "total": 3500
  },
  {
    "type": "B",
    "month1": 800,
    "month2": 920,
    "month3": 760,
    "month4": 870,
    "month5": 990,
    "month6": 960,
    "total": 5300
  },
  {
    "type": "C",
    "month1": 1000,
    "month2": 1200,
    "month3": 1100,
    "month4": 980,
    "month5": 950,
    "month6": 1020,
    "total": 6250
  },
  {
    "type": "Other",
    "month1": 400,
    "month2": 500,
    "month3": 550,
    "month4": 480,
    "month5": 530,
    "month6": 440,
    "total": 2900
  }
]
